
// import Swiper JS
import Swiper, { Navigation } from 'swiper';
// // import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

Swiper.use([Navigation]);

let sliders = [];

const swipers = document.querySelectorAll('.swiper');

if( swipers ){

    for( let i=0; i< swipers.length; i++ ) {

        let args =  JSON.parse(swipers[i].getAttribute('data-options'));

        if ( args.pagination ) {

            args.pagination.renderBullet = function (index, className) {

                let width = 100/args.count;
                return '<span style="width:' + width + '%;" class="' + className + '">' + "</span>";
                    
            };
        }

        // Init Swiper
        sliders[i] = new Swiper( swipers[i],args );

        // Remove options
        // swipers[i].removeAttribute( 'data-options' );

        // Set Status 
        // swipers[i].setAttribute( 'data-status', 'loaded' );
        
    }

}
//


// import sliders from './Swiper.js';

// export default sliders;


///node_modules\swiper\swiper-bundle.min.js